import React from 'react';
import { StyledContainer, styles } from './BrowseCategoryBanner.styles';
import { ButtonV2, TextV2 } from '@withjoy/joykit';
import { SkeletonText, SkeletonThumbnail } from '@shared/components/Skeleton';
import { useTranslation } from '@shared/core/i18n/useTranslation';

interface BrowseCategoryBannerProps {
  categoryTitle: string;
  onBrowseCategoryClick: () => void;
}

const BrowseCategoryBanner = ({ categoryTitle, onBrowseCategoryClick }: BrowseCategoryBannerProps) => {
  const { t } = useTranslation('catalogRegistry');
  const translations = t('browseCategoryBanner');

  return (
    <StyledContainer
      __css={styles.container}
      onClick={onBrowseCategoryClick}
    >
      <TextV2
        __css={styles.title}
        typographyVariant={['hed6', 'display1']}
        fontWeight="semibold"
        lineHeight={[null, '140%']}
      >
        {categoryTitle}
      </TextV2>
      <ButtonV2
        variant="outline"
        color="mono14"
        borderColor="mono14"
        borderWidth="1px"
        _hover={{ backgroundColor: 'mono3', borderColor: 'mono14', color: 'mono12' }}
        _active={{ backgroundColor: 'mono5', borderColor: 'mono14', color: 'mono14' }}
      >
        {translations.browseButton()}
      </ButtonV2>
    </StyledContainer>
  );
};

BrowseCategoryBanner.Skeleton = () => {
  return (
    <StyledContainer __css={styles.container}>
      <SkeletonText
        rows={2}
        skeletonHeight={38}
        width={300}
        marginBottom={5}
      />
      <SkeletonThumbnail
        variant="square"
        width={150}
        height={9}
      />
    </StyledContainer>
  );
};

export default BrowseCategoryBanner;
